import { Box, Button, Typography } from '@mui/joy';
import { ArrowSquareOut } from '@phosphor-icons/react';

export default function InvoicePaymentLink({ url }: { url?: string }) {
  let href = '';
  try {
    const parsed = new URL(url?.trim() || '');
    if (['https:', 'http:'].includes(parsed.protocol)) href = url!.trim();
  } catch { /* No configured payment destination. */ }
  if (!href) return null;
  return <Box sx={{ mt: 2, p: 1.5, borderRadius: 'sm', bgcolor: 'background.level1' }}>
    <Typography level="title-sm">Online payment</Typography>
    <Typography level="body-xs" sx={{ mb: 1 }}>Use your organization’s payment page. Reference this invoice when paying.</Typography>
    <Button component="a" href={href} target="_blank" rel="noopener noreferrer" variant="outlined" fullWidth endDecorator={<ArrowSquareOut />}>Open payment link</Button>
    <Typography level="body-xs" sx={{ mt: 1, overflowWrap: 'anywhere' }}>{href}</Typography>
  </Box>;
}
